import React from 'react';
import TopNavigation from '../TopNavigation';
import Footer from '../Footer';
import ChatWidget from '../ChatWidget';

/**
 * 页面布局组件 - 为所有页面提供统一的布局结构
 * 包含顶部导航、主要内容区域、页脚和聊天组件
 */
const PageLayout = ({ children, showHeader = false }) => {
  return (
    <>
      <TopNavigation />
      {children}
      <Footer />
      {/* <ChatWidget /> */}
    </>
  );
};

export default PageLayout;
